import React, { useCallback, useContext, useRef } from 'react'
import OfferCapacityWithAgesSelectBox from './OfferCapacityWithAgesSelectBox'
import OfferCapacityWithAgesSelection from './OfferCapacityWithAgesSelection'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import OfferPageStateTrackingContext from 'contexts/OfferPage/offerPageStateTrackingContext'
import DeprecatedDropdown from 'components/Luxkit/Dropdown/DeprecatedDropdown'
import DeprecatedDropdownContainer from 'components/Luxkit/Dropdown/DeprecatedDropdownContainer'
import styled from 'styled-components'
import { rem } from 'polished'
import { Placement } from '@floating-ui/react-dom'
import { useIsMobileScreen } from 'lib/web/deviceUtils'
import { validateSemiForm } from 'lib/forms/formUtils'

const Container = styled(DeprecatedDropdownContainer)`
  width: ${rem(800)};
  max-height: ${rem(552)};
`

interface Props {
  open: boolean;
  capacities?: Array<App.PackageRoomCapacity>;
  disclaimer?: string;
  occupantUnit?: 'guest' | 'traveller';
  childrenAgeLabel?: string
  onApply?: () => void
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  dropdownPosition?: Placement;
  anchorRef?: React.RefObject<HTMLElement>;
  disableMultiRoom?: boolean;
  className?: string;
  iconDisabled?: boolean
}

function OfferCapacityWithAgesSelect(props: Props) {
  const {
    open,
    capacities,
    disclaimer,
    occupantUnit = 'guest',
    childrenAgeLabel = 'at time of check-in',
    onApply,
    disableMultiRoom,
    onClick,
    dropdownPosition,
    anchorRef,
    className,
    iconDisabled,
  } = props
  const trigger = useRef(null)
  const container = useRef<HTMLDivElement>(null)
  const dispatch = useOfferPageDispatch()
  const { trackEvent } = useContext(OfferPageStateTrackingContext)
  const isMobile = useIsMobileScreen()

  const onApplyClose = useCallback < React.MouseEventHandler<HTMLButtonElement>>(() => {
    if (validateSemiForm(container.current!)) {
      dispatch({ type: OfferPageActions.closeFilter })
      trackEvent('OCCUPANCY_FILTERS_CLOSED')
    }
  }, [dispatch, trackEvent])

  return (
    <div ref={container} className={className}>
      <OfferCapacityWithAgesSelectBox
        ref={trigger}
        occupantUnit={occupantUnit}
        onClick={onClick}
        multiRoomDisabled={disableMultiRoom}
        iconDisabled={iconDisabled}
      />
      <DeprecatedDropdown
        open={open && !isMobile}
        onClose={onApplyClose}
        triggerRef={trigger}
        anchorRef={anchorRef}
        data-testid="OfferCapacitySelect"
        disableFlip
        position={dropdownPosition}
      >
        <Container
          title="Who is going?"
          fit="container"
        >
          <OfferCapacityWithAgesSelection
            disclaimer={disclaimer}
            capacities={capacities}
            childrenAgeLabel={childrenAgeLabel}
            onApply={onApply}
            disableMultiRoom={disableMultiRoom}
          />
        </Container>
      </DeprecatedDropdown>
    </div>
  )
}

export default withOfferPageState(
  (state) => ({
    open: state.activeFilter === 'capacity',
  }))(OfferCapacityWithAgesSelect)
